import { useState, useMemo } from 'react';

import lodash from 'lodash';

import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './DelegationPopoverTask.scss';

const useStyles = makeStyles({
    paper: {
        width: '250px',

        marginTop: '6px',
        border: '2px solid rgba(200,219,255,1)',
    },
});

const DelegationPopoverTask = ({ tasks }) => {
    const classes = useStyles();
    const taskSortByIndex = useMemo(
        () =>
            tasks.sort((firstTaskIndex, secondTaskIndex) => [
                firstTaskIndex.taskIndex - secondTaskIndex.taskIndex,
            ]),
        [tasks]
    );

    const taskCount = taskSortByIndex.length;
    const singular = taskCount === 1;
    const totalTask = `${taskCount} Task${singular ? '' : 's'} Assigned`;

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className={styles.container}>
            <div onClick={handleClick} className={styles.task__info}>
                <span>{totalTask}</span>
                <ExpandMoreIcon className={styles.expandMoreIcons} />
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                classes={{
                    paper: classes.paper,
                }}
            >
                <div className={styles.task}>
                    <div className={styles.task__desc}>{totalTask}</div>
                    <div className={styles.task__list}>
                        {
                            taskSortByIndex.map(task => {
                                return (
                                    <div className={styles.task__items} key={lodash.get(task, 'taskId')}>
                                        <span>{`${lodash.get(task, 'taskIndex')}. `}</span>
                                        <span>{lodash.get(task, 'taskName')}</span>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default DelegationPopoverTask;
